import { isPrivate } from 'src/config/private';

const domainConfig = {
    local: {
        gateway: '',
    },
    oa: {
        gateway: 'testgateway.qidian.qq.com',
    },
    online: {
        gateway: 'gateway.qidian.qq.com',
    },

    private: {
        gateway: '',
    },
};

function getDomainByEnv() {
    const { hostname } = window.location;
    const env = hostname.split('.')[0];
    let domainObj = {};
    let currEnv = '';

    // 包含oa，并且oa为头两个字母，表明为测试环境
    if (isPrivate) {
        currEnv = 'private';
    } else if (/^local/.test(env)) {
        currEnv = 'local';
    } else if (isPrivate) {
        currEnv = 'private';
    } else if (/^oa/.test(env)) {
        currEnv = 'oa';
    } else {
        currEnv = 'online';
    }

    domainObj = domainConfig[currEnv];

    Object.keys(domainObj).forEach((k) => {
        const dVal = domainObj[k];
        if (dVal) {
            domainObj[k] = `//${dVal}`;
        }
    });

    return domainObj;
}

const envDomain = getDomainByEnv();

export { domainConfig, envDomain, isPrivate };
